export default {
  addTitle: '添加名单',
  vipLabel: 'VIP 名单 · 分配到锁定的 VIP 座位',
  vipHint: '适用于本次手动或批量添加的全部人员。勾选后自动分配至 VIP 空位，不足时保持待分配。',
  manualTitle: '手动添加人员名单',
  manualNamePlaceholder: '请输入姓名',
  manualPhonePlaceholder: '请输入手机号（选填）',
  manualOrganizationPlaceholder: '请输入单位（选填）',
  manualJobTitlePlaceholder: '请输入职务（选填）',
  manualOrderPlaceholder: '数字越小越先',
  manualAdd: '添加人员',
  manualNameRequired: '请输入姓名',
  manualOrderInvalid: '自动补位顺序请输入正整数',
  batchTitle: '批量添加',
  downloadTemplate: '下载模板（CSV）',
  upload: '上传名单',
  templateHint: '模板列：姓名、手机号（选填）、单位、职务（选填）、自动补位顺序（选填，数字越小越先安排）',
  pendingCount: '待添加人员 {count} 位',
  pendingTitle: '待添加人员',
  pendingUnit: '位',
  invalidCount: '已忽略 {count} 行无效数据',
  invalidRows: '第 {rows} 行姓名或数据无效',
  name: '姓名',
  phone: '手机号',
  organization: '单位',
  jobTitle: '职务',
  autoFillOrder: '自动补位顺序',
  remove: '删除',
  empty: '还没有待添加人员',
  addButton: '添加到报名名单',
  addSuccess: '名单已添加',
  parseFailed: 'CSV 解析失败'
}
